module.exports = require("@swa-ui/itinerary/src/IndicatorTooltip/IndicatorTooltip.module.scss");